export default {
  en: {
    'components.reference-capture-modal.message':
      'You need to capture the tax office reference number before you can proceed with the filing.',
    'components.reference-capture-modal.title': 'Tax Office Reference',
  },
};
